import React, { CSSProperties, ReactElement, ReactNode } from 'react'
import {CenterFlex, ColFlex, RowFlex} from '../Components/Misc'
import { isMobile } from 'react-device-detect'
import { PieChart } from 'react-minimal-pie-chart'
import { AppState, AppStateContext, AvatarType } from '../App'


export const standardGap = '2vh'
export const largeGap = '6vh'
export const smallGap = '1vh'
export const bigGap = '10vh'
export const standardBorder = {
    width: '0.15vh',
}
export const standardPadding = '2vh'

const capsuleButton = {
    height: '5.5vh',
    fontSize: '1.5vh',
}

const noTextSelect: CSSProperties = {
    userSelect: 'none',
    WebkitUserSelect: 'none',
    msUserSelect: 'none',
}


export const palettePoste = {
    yellow: '#1c9ec7',
    white: 'white',
    lightGrey: '#e1e3e6',
    darkGrey: '#c6c6c6',
    veryDarkGrey: '#706f6f',
    black: 'black',
    blue: '#0047bb',
}
type ThemePalette = {
    bottomBar: string,
    mainBg: string,
    mainButtonBg: string,
    buttonBorder: string,
    inputBg: string,

    buttonBgHovered: string,

    chatBg: string,
    chatSentBg: string,
    chatSentText: string,
    chatReceivedBg: string,
    chatReceivedText: string,
}
export const lightPalette: ThemePalette = {
    bottomBar: palettePoste.white,
    mainBg: palettePoste.white,
    mainButtonBg: palettePoste.lightGrey,
    buttonBorder: palettePoste.black,
    inputBg: palettePoste.white,

    buttonBgHovered: palettePoste.lightGrey,

    chatBg: 'transparent',
    chatSentBg: '#f2f2f2',
    chatSentText: palettePoste.veryDarkGrey,
    chatReceivedBg: '#d3e2fe',
    chatReceivedText: palettePoste.veryDarkGrey,
}
export const darkPalette: ThemePalette = {
    bottomBar: palettePoste.white,
    mainBg: palettePoste.white,
    mainButtonBg: palettePoste.lightGrey,
    buttonBorder: palettePoste.black,
    inputBg: palettePoste.white,

    buttonBgHovered: palettePoste.lightGrey,

    chatBg: 'transparent',
    chatSentBg: '#f2f2f2',
    chatSentText: palettePoste.veryDarkGrey,
    chatReceivedBg: '#d3e2fe',
    chatReceivedText: palettePoste.veryDarkGrey,
}
export const getThemePalette = (appState: AppState) =>
    appState._tag === 'logged_in'
        ? appState.theme === 'light'
            ? lightPalette
            : darkPalette
        : lightPalette

export const palette = {
    mainBg: 'white',
    boxBg: '#f5f5f5',
    textHighlight: '#6198b4',
    accent: '#9ebdce',
    notSoDarkText: '#545454',
    pieBg: '#cbcbcb',

    buttonBorderColor: '#808080',

    orientationBg: 'white',
    inputBg: 'white',
    buttonBgHovered: '#aaaaaa',
    pdfBg: 'grey',

    poweredByColor: 'grey',
}

export const getAvatarImagePath = (avatarType: AvatarType) =>
    // 'images/avatar-' + (avatarType === 'male' ? 'm' : 'f') + '.jpg'
    'images/avatar-Lia.png'

export const baseTextSize = '2vh'//'1.25rem'
export const BaseLabel = (props: {text: string, style?: CSSProperties}) =>
    <span style={{fontSize: baseTextSize, ...props.style}}>{props.text}</span>

export const LargeLabel = (props: {text: string, style?: CSSProperties}) =>
    <BaseLabel text={props.text}  style={{fontSize: '3vh', ...props.style}} />

export const LargeBoldLabel = (props: {text: string, style?: CSSProperties}) =>
    <BaseLabel text={props.text}  style={{fontSize: '2vh', fontWeight: 900, WebkitTextStroke: "0.5px black", fontFamily: "Poppins, sans-serif", ...props.style}} />

export const CapsuleButton = (props: {text: string, onPress: () => void, bgColor?: string, noBorder?: boolean, containerStyle?: CSSProperties, selected?: boolean, enabled?: boolean}) => {
    const isEnabled = props.enabled ?? true
    return <CenterFlex
        onPress={isEnabled ? props.onPress : undefined}
        style={{
            opacity: isEnabled ? undefined : 0.3,
            borderStyle: props.noBorder ? 'none' : 'solid',
            borderColor: palette.buttonBorderColor,
            borderWidth: standardBorder.width,
            height: capsuleButton.height,
            borderRadius: capsuleButton.height,
            fontSize: capsuleButton.fontSize,
            backgroundColor: props.selected ? palette.textHighlight : (props.noBorder ? undefined : (props.bgColor ?? palettePoste.yellow)),
            padding: standardPadding,
            ...noTextSelect,
            ...props.containerStyle,
        }}
        hoverBgColor={palette.buttonBgHovered}
    >
        {props.text}
    </CenterFlex>
}

export const MultiCapsuleButton = (props: {
    texts: string[],
    selectedIndex: number,
    onPress: (text: string, index: number) => void,
    selBgColor: string,
    bgColor?: string,
    containerStyle?: CSSProperties,
}) =>
    <CenterFlex
        style={{
            borderStyle: 'solid',
            borderColor: palette.buttonBorderColor,
            borderWidth: standardBorder.width,
            height: capsuleButton.height,
            borderRadius: capsuleButton.height,
            backgroundColor: props.bgColor,
            paddingTop: standardPadding,
            paddingBottom: standardPadding,
            ...props.containerStyle,
        }}
    >
        {props.texts.map((t, i) =>
            <CapsuleButton
                key={t}
                text={t}
                onPress={() => props.onPress(t, i)}
                bgColor={props.selectedIndex === i ? props.selBgColor : undefined}
                noBorder={props.selectedIndex !== i}
            />
        )}
    </CenterFlex>

export const CapsuleInput = (props: {placeholder: string, value: string, onChange: (newValue: string) => void, onPressEnter?: () => void, password?: boolean, style?: CSSProperties}) =>
    <input
        placeholder={props.placeholder}
        type={props.password ? 'password' : undefined}
        value={props.value}
        onChange={ev => props.onChange(ev.target.value)}
        onKeyUp={ev => {
            if (props.onPressEnter && ev.key === 'Enter') {
                props.onPressEnter()
                if (isMobile) {
                    ;(ev.target as any).blur() // per mandare via la virtual keyboard su mobile
                }
            }
        }}
        style={{
            boxSizing: 'border-box',
            fontSize: capsuleButton.fontSize,
            display: 'flex',
            margin: 0,
            height: capsuleButton.height,
            paddingLeft: standardPadding,
            paddingRight: standardPadding,
            borderStyle: 'solid',
            borderWidth: standardBorder.width,
            borderRadius: capsuleButton.height,
            ...props.style,
        }}
    />

export const PasswordInput = (props: {
    placeholder: string, 
    value: string, 
    onChange: (newValue: string) => void, 
    onPressEnter?: () => void, 
    style?: CSSProperties
}) => {
    const [showPassword, setShowPassword] = React.useState(false)
    
    return (
    <div style={{ position: 'relative', width: '100%' }}>
        <input
        placeholder={props.placeholder}
        type={showPassword ? 'text' : 'password'}
        value={props.value}
        onChange={ev => props.onChange(ev.target.value)}
        onKeyUp={ev => {
            if (props.onPressEnter && ev.key === 'Enter') {
            props.onPressEnter()
            if (isMobile) {
                ;(ev.target as any).blur() // to hide virtual keyboard on mobile
            }
            }
        }}
        style={{
            boxSizing: 'border-box',
            fontSize: capsuleButton.fontSize,
            display: 'flex',
            margin: 0,
            height: capsuleButton.height,
            paddingLeft: standardPadding,
            paddingRight: '40px', // make room for the eye icon
            borderStyle: 'solid',
            borderWidth: standardBorder.width,
            borderRadius: capsuleButton.height,
            width: '100%',
            ...props.style,
        }}
        />
        <div 
        onClick={() => setShowPassword(!showPassword)}
        style={{
            position: 'absolute',
            right: '15px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            userSelect: 'none',
            fontSize: '16px'
        }}
        >
        {showPassword ? <EyeOpenIcon/> : <EyeClosedIcon/>}
        </div>
    </div>
    )
}

const EyeOpenIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 12s4-8 10-8 10 8 10 8-4 8-10 8-10-8-10-8z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </svg>
  );
  
const EyeClosedIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12s4-8 10-8 10 8 10 8-4 8-10 8-10-8-10-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
    <line x1="2" y1="2" x2="22" y2="22" strokeWidth="2.5"></line>
</svg>
);

export const RectInput = (props: {placeholder: string, value: string, onChange: (newValue: string) => void, onPressEnter?: () => void, style?: CSSProperties}) =>
    <CapsuleInput {...props} style={{borderRadius: '1vh', fontSize: capsuleButton.fontSize, height: capsuleButton.height, ...props.style}} />


export const RectButton = (p: {text: string, onPress: () => void, containerStyle?: CSSProperties, enabled?: boolean}) => {
    const offset = '0.4vh'
    const radius = '0.4vh'

    const isEnabled = p.enabled ?? true

    return <CenterFlex
        style={{
            alignSelf: 'center',
            opacity: isEnabled ? undefined : 0.3,
            ...p.containerStyle,
        }}
    >
        <CenterFlex
            onPress={isEnabled ? p.onPress : undefined}
            hoverBgColor={isEnabled ? palette.buttonBgHovered : undefined}
            style={{
                marginRight: offset,
                marginBottom: offset,
                borderStyle: 'solid',
                borderRadius: radius,
                borderWidth: standardBorder.width,
                borderColor: palette.buttonBorderColor,
                backgroundColor: palette.mainBg,
                zIndex: 1,
                fontSize: capsuleButton.fontSize,
                minHeight: '6vh',
                paddingLeft: standardPadding,
                paddingRight: standardPadding,
                whiteSpace: 'pre-line',
                ...noTextSelect,
            }}
        >
            {p.text}
        </CenterFlex>
        <CenterFlex
            style={{
                position: 'absolute',
                top: offset,
                left: offset,
                bottom: 0,
                right: 0,
                backgroundColor: palette.textHighlight,
                borderRadius: radius,
                boxShadow: '0.15vh 0.15vh 0.75vh #b0b0b0',
            }}
        >

        </CenterFlex>
    </CenterFlex>
}

export const TextOnlyButton = (p: {text: string, onPress: () => void, containerStyle?: CSSProperties}) => {
    return (
        <CenterFlex
            style={{...p.containerStyle}}
            onPress={p.onPress}
            hoverBgColor={lightPalette.buttonBgHovered}
        >
            <BaseLabel text={p.text} style={{color: palettePoste.blue}} />
        </CenterFlex>
    )
}


export const DonutChart = (p: {label: string, percent: number, showNumberAsTenths?: boolean}) =>
    <ColFlex key={p.label}>
        <CenterFlex>
            <PieChart
                data={[{color: palette.textHighlight, value: p.percent}, {color: palette.pieBg, value: 100 - p.percent}]}
                startAngle={-90}
                lineWidth={25}
                paddingAngle={p.percent > 0 && p.percent < 100 ? 3 : 0}
                style={{position: 'relative', display: 'flex', height: '10vh'}}
            />
            <BaseLabel style={{position: 'absolute'}} text={
                p.showNumberAsTenths
                ? Math.round(p.percent / 10).toString() + '/10'
                : Math.round(p.percent).toString() + '%'
            } />
        </CenterFlex>
        <BaseLabel text={p.label} style={{width: '20vh'}} />
    </ColFlex>

export const PosteScreenWrapper = (p: {initial: boolean, children?: ReactNode, containerStyle?: CSSProperties}) => {
    const appState = React.useContext(AppStateContext)
    const themePalette = getThemePalette(appState)
    
    const logosHeight = '6.5vh'
    const barsPadding = standardPadding + ' calc(2 * ' + standardPadding + ')'
    
    return <ColFlex expand style={{width: '100vw', height: '100vh', overflow: 'hidden', backgroundColor: palette.mainBg, ...p.containerStyle}}>
        <RowFlex style={{padding: standardPadding}}>
            <CenterFlex style={{flex: 1}} />
            <img alt='Archetype' src='https://arche-type.net/wp-content/uploads/2025/07/logo-Archetype.png' style={{height: logosHeight}} />
            {/* <img alt='labai' src='images/logo_corporate-univ.png' style={{height: logosHeight}} /> */}
        </RowFlex>
        <CenterFlex style={{flex: 1}}>
            {p.children}
        </CenterFlex>
        <RowFlex style={{padding: standardBorder.width, flexDirection: 'row-reverse', backgroundColor: p.initial ? palettePoste.yellow : themePalette.mainBg}}>
            {/* <img alt='logo' src='images/logo.png' style={{height: logosHeight}} /> */}
            <div style={{flex: 1, textAlign: 'right', fontSize: '0.8rem'}} >© 2025 ARCHETYPE AI Knowledge Lab. </div>
        </RowFlex>
    </ColFlex>
}